// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609280506/js/" + chunkId + "." + {"44":"69dec68d","225":"7baf3f61","481":"dd158c09","486":"a6cfa804","770":"00670e3b"}[chunkId] + ".0.7824576617073472.chunk.js";
};